'use client'

import React, { useEffect, Suspense } from 'react'
import { usePathname } from 'next/navigation'
import clsx from 'clsx'
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import SideNav from '@/components/SideNav'
import ProfileNav from '@/components/Profile/ProfileNav'
import NonMemberModal from '@/components/Shared/NonMemberModal'
import MessageAfterLogin from '@/components/Shared/MessageAfterLogin'
import { useNavigationState } from '@/hooks/useNavigationState'
import { useAuth } from '@/hooks/useAuth'
import styles from './styles.module.scss'

export default function MemberLayout({ children }: { children: React.ReactNode }) {
  const pathname = usePathname()
  const { beforePath, removeBeforePath } = useNavigationState()
  const { getMemberId } = useAuth()

  useEffect(() => {
    const currentPathName = getRouteName(pathname)

    // login後のリダイレクトPathが/members/mypageなのでmypageは除外
    const excludeNames = ['members-mypage']

    // 現在のパスが excludeNames 以外の場合にのみ クリア処理を実行
    if (beforePath && !excludeNames.includes(currentPathName)) {
      removeBeforePath()
    }
  }, [pathname, beforePath, removeBeforePath])

  function getRouteName(path: string | null): string {
    if (!path) return ''
    const segments = path.split('/')
    return segments[segments.length - 1] || 'index'
  }

  const isProfilePage = pathname?.startsWith('/members/profile')

  return (
    <div className='mypage-container'>
      <Header />
      <div id='app'>
        <div className={clsx(styles.mypageWrapper, { [styles.profileWrapper]: isProfilePage })}>
          <div
            className={clsx(styles.sidenavContainer, {
              [styles.profileNavContainer]: isProfilePage,
            })}
          >
            {isProfilePage ? (
              <Suspense fallback={null}>
                <ProfileNav />
              </Suspense>
            ) : (
              <SideNav />
            )}
          </div>
          <div className={styles.mypageContentsContainer}>{children}</div>
        </div>
      </div>
      <NonMemberModal />
      <MessageAfterLogin memberId={getMemberId()} />
      <Footer />
    </div>
  )
}
